export default __webpack_public_path__ + "static/media/Group 1415.ca4038af.png";